// Sizes from docs/ui-standard.md §2: page title 26–30 (h3), section title
// 17–20 (h4/h5), body 15 (body1), small 13 (body2). Numbers, prices and
// references use `fontFamilyMono` (the standard's font-data).
export const fontFamilyMono =
  "ui-monospace, 'SFMono-Regular', 'JetBrains Mono', Menlo, Consolas, monospace";

const typography = {
  fontFamily: "'Figtree', 'Segoe UI', system-ui, sans-serif",
  fontFamilyMono,
  h1: {
    fontWeight: 700,
    fontSize: '2.25rem',
    lineHeight: 1.25,
  },
  h2: {
    fontWeight: 700,
    fontSize: '1.875rem',
    lineHeight: 1.25,
  },
  h3: {
    fontWeight: 700,
    fontSize: '1.75rem',
    lineHeight: 1.25,
    letterSpacing: '-0.01em',
  },
  h4: {
    fontWeight: 700,
    fontSize: '1.25rem',
    lineHeight: 1.35,
  },
  h5: {
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: 1.4,
  },
  h6: {
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: 1.4,
  },
  button: {
    textTransform: 'none',
    fontWeight: 600,
  },
  body1: {
    fontSize: '0.9375rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body2: {
    fontSize: '0.8125rem',
    letterSpacing: 0,
    fontWeight: 400,
    lineHeight: 1.45,
  },
  subtitle1: {
    fontSize: '0.9375rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  subtitle2: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.45,
  },
  caption: {
    fontSize: '0.75rem',
    lineHeight: 1.4,
  },
  overline: {
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '0.04em',
    lineHeight: 1.6,
  },
};

export default typography;
